import {
  Component,
  effect,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  Output,
} from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import {
  AbstractControl,
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { SharedModule } from 'primeng/api';
import { FormFieldWrapperComponent } from '../../molecules/form-field-wrapper/form-field-wrapper.component';
import { TagStore } from '../../../stores/tag/tag.state';
import { NgIf } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { Button } from 'primeng/button';
import { Tag } from '../../../models/tag';
import { GlobalsStore } from '../../../stores/globals.state';
import { getState } from '@ngrx/signals';

@Component({
  selector: 'app-tag-dropdown',
  standalone: true,
  imports: [
    DropdownModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    FormFieldWrapperComponent,
    NgIf,
    MultiSelectModule,
    Button,
  ],
  templateUrl: './tag-dropdown.component.html',
  styleUrl: './tag-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagDropdownComponent),
      multi: true,
    },
  ],
})
export class TagDropdownComponent implements ControlValueAccessor {
  readonly tagStore = inject(TagStore);
  readonly globalsStore = inject(GlobalsStore);

  selection: string[] = [];
  touched = false;
  disabled = false;

  tags: Tag[] = [];

  @Input() enableNewOption = false;
  @Input() label = 'Schlagworte';
  @Input() name = 'tag';
  @Input() colSize: string | number = 12;
  @Input() mode: 'all' | 'commune' | 'global' | 'inUse' = 'commune';
  @Input() formField: AbstractControl | null = null;
  @Output() selectionChange = new EventEmitter<string[] | null>();

  constructor() {
    effect(() => {
      const tagState = getState(this.tagStore);
      this.tags = this.tagStore.asArray();

      if (tagState.selectedId) {
        queueMicrotask(() => {
          this.writeValue([...this.selection, tagState.selectedId]);
          this.selectionChange.emit(this.selection);
        });
      }
    });
  }

  protected onChange = (value: any) => {
    setTimeout(() => {
      this.selectionChange.emit(value);
    }, 100);
  };

  private onTouched = () => {
    this.touched = false;
  };

  writeValue(value: any): void {
    this.selection = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  selectIcon(tag: any): void {
    this.selection = tag;
    this.onChange(tag);
    this.onTouched();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  openTagForm() {
    this.globalsStore.triggerAtlasEvent('addTagDialog', {});
  }
}
